export default (target, source, except = []) => {
    Object.keys(target).map(key => _.snakeCase(key) in source && !except.includes(key) && !!source[_.snakeCase(key)] && (target[key] = source[_.snakeCase(key)]));
}
